import React, { useState, useEffect, useRef, useCallback } from 'react'
import ErrorAlert from '../../components/Alerts/ErrorAlert';
import stand from '../../assets/img/vending/stand.png'
import defaultImg from '../../assets/img/vending/default.png'
import { RenderIf } from '../../components/utils/RenderIf';
import VendingModalCart from './VendingModalCart';
import Vendingoutservice from './Vendingoutservice';
import { Modal } from 'react-bootstrap';
import { BiCartDownload } from 'react-icons/bi';
import { OrderNumberFetchAPI } from '../../api/Paymentpost/OrderNumber';
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';
// =========================================================================
// CSS del nuevo layout del modal — scoped bajo .vmp-root
// =========================================================================
const VMP_CSS = `

`;

// =========================================================================
// SUB-COMPONENTE: slide individual del producto
// =========================================================================
function ProductSlide({ product, stateClass, animateIn, fromDirection }) {
  const [mounted, setMounted] = useState(!animateIn);

  useEffect(() => {
    if (!animateIn) return;
    const raf = requestAnimationFrame(() => {
      requestAnimationFrame(() => setMounted(true));
    });
    return () => cancelAnimationFrame(raf);
  }, [animateIn]);

  let cls = "vmp-slide";
  if (!animateIn) {
    cls += ` ${stateClass || "is-current"}`;
  } else {
    cls += !mounted
      ? (fromDirection === 1 ? " is-enter-from-right" : " is-enter-from-left")
      : " is-current";
  }

  const stock = product?.stock ?? 0;
  const priceNum = parseFloat(product?.price ?? 0) - parseFloat(product?.product_discount ?? 0);

  return (
    <div className={cls}>
      <div className="vmp-slide-media">
        <img src={product?.img ? buildCloudinaryImageUrl({url: product?.img, width: 300, type: "image", quality: "auto"}) : defaultImg} alt={product?.name || "producto"} loading="lazy" />
        {(product?.X != null && product?.Y != null) && (
          <span className="vmp-slide-slot">{product.X}-{product.Y}</span>
        )}
        <span className={`vmp-slide-stock ${stock > 0 ? "is-ok" : "is-out"}`}>
          {stock > 0 ? "Disponible" : "Agotado"}
        </span>
      </div>
      <h3 className="vmp-slide-name" title={product?.name}>{product?.name}</h3>
      <div className="vmp-slide-price">
        <small>$</small>{isNaN(priceNum) ? "0.00" : priceNum.toFixed(2)}
      </div>
    </div>
  );
}


// =========================================================================
// COMPONENTE PRINCIPAL — toda la lógica original preservada
// =========================================================================
function VendingModalProduct({ selectGroup, setShoppingCart, shoppingCart, showModalProduct, setShowModalProduct, setShowModalShopingCart, setEventHandlerMenu, showModalShopingCart, dataClient, setDataClient, groups, setSelectGroup, getGroupById, showModalPayment, setShowModalPayment, setStatusScreen, statusScreen, getTemp, statusComunicationVending, amount, setAmount,
  showModaloutService, setShowModaloutService, orderNumber, setOrderNumber, addProduct, getOrderNumber, payments, setPayments, oledScreenPayments, setStatusTempTurnNow, setAtivityTimer
}) {
  //const [showModalPayment, setShowModalPayment] = useState(false);
  const [eventHandler, setEventHandler] = useState(0)
  const [eventHandlerLoader, setEventHandlerLoader] = useState(0)
  let business = localStorage.getItem('business_vending');
  let businessCode = ""

  if (business != null && business != '' && business != undefined) {
    business = JSON.parse(localStorage.getItem('business_vending'));
    businessCode = business.code
    console.log(business.code)
  }

  //console.log(selectGroup);
  //increment amount
  const buttonPlus = () => setAmount(amount + 1);
  //decrement amount
  const buttonDecrease = () => {
    if (amount > 1) {
      setAmount(amount - 1)
    }
  }


  //Next Product
  const nextProduct = () => {

    let index = selectGroup.index
    const array = groups.filter(producto => producto.name !== null && producto.amount > 0);

    const productNoNulls = [];

    array.forEach(p => {
      if (productNoNulls.findIndex(item => item.group_id === p.group_id) === -1) {
        // No existe; al detectar que no existe el mismo nombre, "la copiamos"
        productNoNulls.push(p);
      }
    });

    ordenarAsc(productNoNulls, 'positionX')
    let nextIndex = (index + 1)

    getGroupById(productNoNulls[nextIndex].group_id, productNoNulls[nextIndex].positionX, productNoNulls[nextIndex].positionY, productNoNulls[nextIndex].amount, productNoNulls[nextIndex].position_id, nextIndex, productNoNulls[nextIndex].detail_group)

    setEventHandlerLoader(1);
  }


  function ordenarAsc(p_array_json, p_key) {
    let newArray = p_array_json.sort(function (a, b) {
      return a[p_key] > b[p_key];
    });


    return (newArray.reverse())
  }

  const afterProduct = () => {

    let index = selectGroup.index
    const array = groups.filter(producto => producto.name !== null && producto.amount > 0);

    const productNoNulls = [];

    array.forEach(p => {
      if (productNoNulls.findIndex(item => item.group_id === p.group_id) === -1) {
        // No existe; al detectar que no existe el mismo nombre, "la copiamos"
        productNoNulls.push(p);
      }
    });

    ordenarAsc(productNoNulls, 'positionX')
    let nextIndex = (index - 1)
    getGroupById(productNoNulls[nextIndex].group_id, productNoNulls[nextIndex].positionX, productNoNulls[nextIndex].positionY, productNoNulls[nextIndex].amount, productNoNulls[nextIndex].position_id, nextIndex, productNoNulls[nextIndex].detail_group)

    setEventHandlerLoader(1);
  }


  //Hook to recharge the component
  useEffect(() => {
    setShoppingCart([...shoppingCart]);
    setEventHandler(0);

  }, [eventHandler]);

  //Hook to recharge the component
  useEffect(() => {
    setEventHandlerLoader(0);
  }, [eventHandlerLoader]);


  // =============================================================
  // NUEVO: lógica de animación slide entre productos + refs
  // =============================================================

  // Lista filtrada y ordenada igual que nextProduct/afterProduct
  // (se recalcula cada render — barato porque son arrays pequeños)
  const getProductList = () => {
    const array = groups.filter(producto => producto.name !== null && producto.amount > 0);
    const productNoNulls = [];
    array.forEach(p => {
      if (productNoNulls.findIndex(item => item.group_id === p.group_id) === -1) {
        productNoNulls.push(p);
      }
    });
    ordenarAsc(productNoNulls, 'positionX');
    return productNoNulls;
  };

  const productList = getProductList();
  const currentListIdx = selectGroup?.index ?? 0;
  const totalProducts = productList.length;

  // Animación slide
  const [prevProduct, setPrevProduct] = useState(null);
  const [direction, setDirection] = useState(0); // 1 = next, -1 = prev
  const transitioningRef = useRef(false);
  const prevIndexRef = useRef(currentListIdx);

  // Detectar cambio del producto actual y disparar animación slide
  useEffect(() => {
    if (!showModalProduct) {
      prevIndexRef.current = currentListIdx;
      setPrevProduct(null);
      return;
    }
    if (currentListIdx !== prevIndexRef.current) {
      const dir = currentListIdx > prevIndexRef.current ? 1 : -1;
      setDirection(dir);
      // Guardar el producto anterior para animar su salida
      setPrevProduct({ ...selectGroup, index: prevIndexRef.current, __stale: true });
      prevIndexRef.current = currentListIdx;
      transitioningRef.current = true;
      setTimeout(() => {
        setPrevProduct(null);
        transitioningRef.current = false;
      }, 480);
    }
  }, [currentListIdx, showModalProduct]);

  // Wrappers de next/prev con bloqueo durante la transición
  const handleNext = useCallback(() => {
    if (transitioningRef.current) return;
    if (currentListIdx >= totalProducts - 1) return;
    setAtivityTimer(7);
    nextProduct();
  }, [currentListIdx, totalProducts]);

  const handlePrev = useCallback(() => {
    if (transitioningRef.current) return;
    if (currentListIdx <= 0) return;
    setAtivityTimer(7);
    afterProduct();
  }, [currentListIdx]);

  const handleClose = () => {
    setShowModalProduct(false);
    setStatusScreen({ screen: "menu" });
    setShoppingCart([]);
    setStatusTempTurnNow(true);
  };

  // Bloquear scroll del fondo mientras el modal está abierto
  useEffect(() => {
    if (!showModalProduct) return;
    const { body, documentElement: html } = document;
    const prev = {
      bodyOverflow: body.style.overflow,
      bodyTouchAction: body.style.touchAction,
      htmlOverflow: html.style.overflow,
      bodyPaddingRight: body.style.paddingRight,
    };
    const scrollbarWidth = window.innerWidth - html.clientWidth;
    if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`;
    body.style.overflow = "hidden";
    html.style.overflow = "hidden";
    body.style.touchAction = "none";

    const preventIfOutside = (e) => {
      const root = document.querySelector(".vmp-root");
      if (root && !root.contains(e.target)) {
        e.preventDefault();
      }
    };
    window.addEventListener("touchmove", preventIfOutside, { passive: false });
    window.addEventListener("wheel", preventIfOutside, { passive: false });

    return () => {
      body.style.overflow = prev.bodyOverflow;
      body.style.touchAction = prev.bodyTouchAction;
      html.style.overflow = prev.htmlOverflow;
      body.style.paddingRight = prev.bodyPaddingRight;
      window.removeEventListener("touchmove", preventIfOutside);
      window.removeEventListener("wheel", preventIfOutside);
    };
  }, [showModalProduct]);

  // Soporte para teclas ← → y Escape
  useEffect(() => {
    if (!showModalProduct) return;
    const onKey = (e) => {
      if (e.key === "ArrowLeft") handlePrev();
      else if (e.key === "ArrowRight") handleNext();
      else if (e.key === "Escape") handleClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [showModalProduct, handleNext, handlePrev]);

  // Inyectar CSS del modal una sola vez
  useEffect(() => {
    const id = "vmp-root-styles";
    if (document.getElementById(id)) return;
    const style = document.createElement("style");
    style.id = id;
    style.textContent = VMP_CSS;
    document.head.appendChild(style);
  }, []);

  const stock = selectGroup?.stock ?? 0;

  return (
    <>
      <Modal
        show={showModalProduct}
        size='lg'
        onHide={() => setShowModalProduct(false)}
        centered
        dialogClassName="vmp-bootstrap-override"
        contentClassName="vmp-bootstrap-override"
      >
        <Modal.Body>
          <div className="vmp-root" onClick={() => setAtivityTimer(7)}>

            {/* ============ HEADER ============ */}
            <header className="vmp-header">
              <span className="vmp-index">
                <b>{currentListIdx + 1}</b> / {totalProducts || 1}
              </span>
              <h2 className="vmp-title">Producto Seleccionado</h2>
              <button
                className="vmp-close"
                onClick={(e) => { e.stopPropagation(); handleClose(); }}
                aria-label="Cerrar"
                title="Volver al menú"
              >
                <i className="uil uil-times"></i>
              </button>
            </header>

            {/* ============ BODY con flechas y slide ============ */}
            <div className="vmp-body">
              <button
                className="vmp-nav"
                onClick={(e) => { e.stopPropagation(); handlePrev(); }}
                disabled={currentListIdx <= 0}
                aria-label="Producto anterior"
              >
                <i className="uil uil-angle-left-b"></i>
              </button>

              <div className="vmp-stage">
                {/* Slide saliente (anterior) */}
                {prevProduct && (
                  <ProductSlide
                    key={`prev-${prevProduct.group_id}-${prevProduct.index}`}
                    product={prevProduct}
                    stateClass={direction === 1 ? "is-exit-left" : "is-exit-right"}
                  />
                )}
                {/* Slide actual */}
                <ProductSlide
                  key={`cur-${selectGroup?.group_id}-${currentListIdx}`}
                  product={selectGroup}
                  animateIn={!!prevProduct}
                  fromDirection={direction}
                />
              </div>

              <button
                className="vmp-nav"
                onClick={(e) => { e.stopPropagation(); handleNext(); }}
                disabled={currentListIdx >= totalProducts - 1}
                aria-label="Siguiente producto"
              >
                <i className="uil uil-angle-right-b"></i>
              </button>
            </div>

            {/* Contador de amount (mantenemos los handlers originales, oculto por defecto) */}
            <div className="vmp-amount" style={{ display: 'none' }}>
              <button onClick={() => buttonDecrease()}>−</button>
              <p>{amount}</p>
              <button onClick={() => buttonPlus()}>+</button>
            </div>

            {/* ============ FOOTER ============ */}
            <footer className="vmp-footer">
              <button
                className="vmp-back"
                onClick={(e) => { e.stopPropagation(); handleClose(); }}
                title="Volver al menú"
              >
                <i className="uil uil-arrow-left"></i>
                Volver
              </button>

              <RenderIf isTrue={stock > 0}>
                <button
                  className="vmp-buy"
                  onClick={(e) => { e.stopPropagation(); addProduct(); }}
                >
                  <i className="uil uil-shopping-cart-alt"></i>
                  Comprar
                </button>
              </RenderIf>
              <RenderIf isTrue={stock == 0 || stock < 0}>
                <button className="vmp-buy" disabled>
                  <i className="uil uil-sad-squint"></i>
                  Agotado
                </button>
              </RenderIf>


            </footer>

          </div>
        </Modal.Body>
      </Modal>


      {/*----------------------------------------*/}
      <VendingModalCart setShoppingCart={setShoppingCart} shoppingCart={shoppingCart} showModalShopingCart={showModalShopingCart}
        setShowModalShopingCart={setShowModalShopingCart} eventHandler={eventHandler} dataClient={dataClient}
        setDataClient={setDataClient} showModalPayment={showModalPayment} setShowModalPayment={setShowModalPayment}
        setEventHandlerMenu={setEventHandlerMenu} setStatusScreen={setStatusScreen} statusComunicationVending={statusComunicationVending}
        groups={groups} orderNumber={orderNumber} setOrderNumber={setOrderNumber} payments={payments} setPayments={setPayments}
        oledScreenPayments={oledScreenPayments} getTemp={getTemp} setAtivityTimer={setAtivityTimer} />


      <Vendingoutservice showModaloutService={showModaloutService} setShowModaloutService={setShowModaloutService} setEventHandlerMenu={setEventHandlerMenu} clearShoppingCart status={0} setAtivityTimer={setAtivityTimer}></Vendingoutservice>


    </>
  )
}

export default VendingModalProduct
